import { Image, Input, Popover, Swiper, Toast, InfiniteScroll } from 'antd-mobile';
import { useState, useEffect, useRef } from "react";
import './Invite.less'
import { jumpPage, ToggleCopy } from '@/utils/common'
import { SwiperRef } from 'antd-mobile/es/components/swiper'
import { onToUserPage } from '@/utils/common'
import { useLocation } from 'react-router-dom';
// api
import { getExpectedReward, postRegisterBind, getInviteRegisterList, postActivityRankList, getInviteDateList } from '@/api/invite'
import { MyRankData, TimeList } from '@/interface/invite'
// 图片
import reward_rules from "@/image/invite/home/reward_rules.png"
import topImg from '@/image/invite/home/bg.png'
import arrow from '@/image/invite/home/arrow.png'
import flowchart from '@/image/invite/home/flowchart.png'
import reward_box from '@/image/invite/home/reward_box.png'
import nav_bar_1 from '@/image/invite/home/nav_bar_1.png'
import nav_bar_2 from '@/image/invite/home/nav_bar_2.png'
import refresh_btn from '@/image/invite/home/refresh_btn.png'
import top_1_bg from '@/image/invite/home/top_1_bg.png'
import top_2_bg from '@/image/invite/home/top_2_bg.png'
import top_3_bg from '@/image/invite/home/top_3_bg.png'
import top4_award from '@/image/invite/home/top4_award.png'
import top5_award from '@/image/invite/home/top5_award.png'
import avatar from '@/image/invite/home/avatar.png'
import invalid_text from '@/image/invite/home/invalid_text.png'
import no_data from '@/image/invite/home/no_data.png'
import clear_btn from '@/image/invite/home/clear_btn.png'

const Invite = () => {
  const { pathname } = useLocation();
  const [tab, setTab] = useState<number>(0)
  const [showTime, setShowTime] = useState<number>(0)
  const [amount, setAmount] = useState<number>(0)
  const [rankList, setRankList] = useState<Array<any>>([])
  const [myRankList, setMyRankList] = useState<Array<any>>([])
  const [visible, setVisible] = useState<number>(0)
  const [code_number, setCodeNumber] = useState<string>('')
  const [visiblePopover, setVisiblePopover] = useState<boolean>(false)
  const [count, setCount] = useState<number>(0)
  const [myRank, setMyRank] = useState<MyRankData>({
    user_id: 0,
    user_nickname: "",
    user_avatar: "",
    rank: 0,
    activity_rank_gap: "",
    activity_value: 0
  })
  const [dateList, setDateList] = useState<Array<TimeList>>([])
  const [current_page, setCurrentPage] = useState<number>(1)

  const ToggleTabBar = (index: number) => {
    setTab(index)
  }

  const [activityDate, setActivityDate] = useState<string>('')
  const getInviteList = (activity_date:string) => {
    setActivityDate(activity_date)

    postActivityRankList({
      activity_code: 'RG_Invite',
      rank_code: 'YQ-MH', // 只有月
      activity_date
    }).then(e => {
      setRankList(e.rank_list || [])
      setMyRank(e.self || '')
      setVisible(e.visable || false)
    })
  }

  const getActivityMyList = (init?:boolean) => {
    getInviteRegisterList({
      page: init ? 1 : current_page,
      limit: 30,
      activity_code: 'RG_Invite'
    }).then(e => {
      let num = current_page
      setCurrentPage(init ? 2 : ++num)
      const arr = e.list || []
      setMyRankList(pref => init ? [...arr] : [...pref, ...arr])
      setCount(e.count)
    })
  }

  const getDateList = () => {
    getInviteDateList({
      activity_code: 'RG_Invite',
      rank_code: 'YQ-MH',
    }).then(e => {
      const time = e[0]?.month
      setShowTime(time)
      setDateList(e)
      getInviteList(e[0].invite_date)
    })
  }

  const onLoad = () => {
    getDateList()
    getActivityMyList(true)

    getExpectedReward().then(e => {
      setAmount(e.amount)
    })
  }

  useEffect(() => {
    onLoad()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    const pageDom = document.querySelector('.invite-page') as HTMLElement;

    const handleScroll = () => {
      const navBarDom = document.querySelector('.bottom-box') as HTMLElement;
      navBarDom.style.display = pageDom.scrollTop >= 350 ? 'flex' : 'none';
    }

    pageDom?.addEventListener('scroll', handleScroll);

    // 组件卸载时移除监听器
    return () => pageDom.removeEventListener('scroll', handleScroll);
  }, [])

  const sumbit = () => {
    if (!code_number) return Toast.show('请先填写邀请码')
    postRegisterBind(code_number).then(() => {
      setCodeNumber('')
      onLoad()
      Toast.show('绑定成功')
    })
  }

  const [rotateBtn, setRotateBtn] = useState<boolean>(false)
  const swiperRef = useRef<SwiperRef>(null)

  return (
    <>
      <section className='invite-page' onClick={() => setVisiblePopover(false)}>
        <section className='top_img'>
          {/* 顶部图片 */}
          <Image src={topImg} fit='contain' width={'100%'} />

          <section>
            {/* 邀请码 */}
            <div className='invitation-number'>
              <section>
                <div>
                  <Input
                    placeholder='请填写邀请码'
                    value={code_number}
                    maxLength={16}
                    onChange={val => setCodeNumber(val)}
                    clearable
                    clearIcon={<Image src={clear_btn} fit='contain' width='6.4vw' />}
                    onClear={() => setCodeNumber('')}
                  />
                  <span className='btn' onClick={sumbit}>提交</span>
                </div>
              </section>
            </div>

            {/* 邀请流程 */}
            <Image src={flowchart} className='flowchart' />

            {/* 预计本周奖励 */}
            <div className='reward_box'>
              <Image src={reward_box} />
              <div className='text'>
                <span className={9 > 10 ? 'long' : ''}>{amount}</span>
                钻石
              </div>
            </div>
          </section>

          {/* 奖励规则按钮 */}
          <aside className="reward_rules" onClick={jumpPage.bind(this, `${pathname}/reward-rules`)}>
            <Image src={reward_rules} />
          </aside>
        </section>

        <div className='bottom'>
          {/* 邀请排行tab */}
          <div className="tab">
            <Image src={tab === 0 ? nav_bar_1 : nav_bar_2} />

            <section>
              <div className={tab === 0 ? 'active-tab' : 'unactive-tab'}>
                <Popover
                  mode='dark'
                  visible={visiblePopover}
                  content={
                    <ul>
                      {
                        dateList.map(e =>
                          <li key={e.month} className={showTime === e.month ? 'active' : ''} onClick={() => {
                            setShowTime(e.month)
                            getInviteList(e.invite_date)
                            setVisiblePopover(false)
                          }}>{e.month}月</li>
                        )
                      }
                    </ul>
                  }
                  placement='bottom'
                  trigger='click'
                >
                  <div className="tab-time" onClick={e => {
                    e.stopPropagation()
                    setVisiblePopover(!visiblePopover)
                  }}>
                    <span>{showTime}月</span>
                    <Image className={visiblePopover ? 'active-arrow' : ''} src={arrow} />
                  </div>
                </Popover>

                {/* 遮罩,如果还未到这个标签激活，就遮住，避免点击到popover */}
                <div className='mask' onClick={e => {
                  e.stopPropagation()
                  ToggleTabBar(0)
                  swiperRef.current?.swipeTo(0)
                }} />
              </div>
              <div className={tab === 1 ? 'active-tab' : ''} onClick={() => {
                ToggleTabBar(1)
                swiperRef.current?.swipeTo(1)
              }}>
                <span>({count}人)</span>
              </div>
            </section>
          </div>

          <Swiper
            indicator={() => null}
            ref={swiperRef}
            defaultIndex={tab}
            onIndexChange={index => {
              ToggleTabBar(index)
            }}
          >
            <Swiper.Item>
              <section>
                <nav>
                  <p>充值1元=1积分，奖励二选一，最终获得者以截榜数据为准</p>
                  <div className={rotateBtn ? 'rotate-btn' : ''} onAnimationEnd={() => setRotateBtn(false)} onClick={() => {
                    getInviteList(activityDate)
                    setRotateBtn(true)
                  }}>
                    <Image className='refresh_btn' src={refresh_btn} />
                  </div>
                </nav>

                <header>
                  <div className='top_2'>
                    <Image src={top_2_bg} />
                    <section>
                      <Image src={rankList[1]?.user_avatar || avatar} className='avatar' onClick={() => onToUserPage(rankList[1]?.user_id)} />
                      {
                        rankList.length >=2 ?
                        <>
                          <h2>{rankList[1].user_nickname}</h2>
                          <b>{rankList[1].activity_rank_gap}</b>
                          <p>距上一名</p>
                        </> :
                        <h1>虚位以待</h1>
                      }
                    </section>
                  </div>
                  <div className='top_1'>
                    <Image src={top_1_bg} />
                    <section>
                      <Image src={rankList[0]?.user_avatar || avatar} className='avatar' onClick={() => onToUserPage(rankList[0]?.user_id)} />
                      {
                        rankList.length >= 1 ?
                        <h2>{rankList[0].user_nickname}</h2> :
                        <h1>虚位以待</h1>
                      }
                    </section>
                  </div>
                  <div className='top_3'>
                    <Image src={top_3_bg} />
                    <section>
                      <Image src={rankList[2]?.user_avatar || avatar} className='avatar' onClick={() => onToUserPage(rankList[2]?.user_id)} />
                      {
                        rankList.length >=3 ?
                        <>
                          <h2>{rankList[2].user_nickname}</h2>
                          <b>{rankList[2].activity_rank_gap}</b>
                          <p>距上一名</p>
                        </> :
                        <h1>虚位以待</h1>
                      }
                    </section>
                  </div>
                </header>

                {
                  rankList.length ?
                  <ul className='invite-list'>
                    {
                      rankList.map((e, i) =>
                        i > 2 ?
                        <li key={i}>
                          <b>{i + 1}</b>
                          <Image src={e.user_avatar || avatar} className='avatar' onClick={() => onToUserPage(e.user_id)} />
                          <div className='title'>{e.user_nickname}</div>
                          <div className='gift'>
                            {
                              (i === 3 || i === 4) ?
                              <Image className={i === 3 ? 'top4_award' : 'top5_award'} src={i === 3 ? top4_award : top5_award} fit="contain" /> : ''
                            }
                          </div>
                          <aside>
                            <h3>{e.activity_rank_gap}</h3>
                            <p>距上一名</p>
                          </aside>
                        </li> : ''
                      )
                    }
                  </ul>
                  :
                  <div className='no_data'>
                    <Image src={no_data} />
                    <p>暂无数据</p>
                  </div>
                }
              </section>
            </Swiper.Item>
            <Swiper.Item>
              <section>
                <nav>
                  <p></p>
                  <div className={rotateBtn ? 'rotate-btn' : ''} onAnimationEnd={() => setRotateBtn(false)} onClick={() => {
                    getActivityMyList(true)
                    setRotateBtn(true)
                  }}>
                    <Image className='refresh_btn' src={refresh_btn} />
                  </div>
                </nav>

                {
                  myRankList.length ?
                  <>
                    <ul className='my-invite-list'>
                      {
                        myRankList.map((e, i) =>
                          <li key={i}>
                            <section>
                              <Image src={e.avatar || avatar} className='avatar' onClick={() => onToUserPage(e.user_id)} />
                              <div className='title'>
                                <h3>{e.user_nickname}</h3>
                                <div>
                                  ID:{e.user_id}
                                  <span className='copy-btn' onClick={() => ToggleCopy(e.user_id)}>复制</span>
                                </div>
                              </div>
                            </section>

                            <aside>
                              {
                                e.invalid_msg ?
                                <Image src={invalid_text} onClick={() => Toast.show(e.invalid_msg)} /> : ''
                              }
                              <p>{e.invite_time}</p>
                            </aside>
                          </li>
                        )
                      }
                    </ul>

                    <InfiniteScroll loadMore={async () => getActivityMyList()} hasMore={myRankList.length < count} />
                  </>
                  :
                  <div className='no_data'>
                    <Image src={no_data} />
                    <p>暂无数据</p>
                  </div>
                }
              </section>
            </Swiper.Item>
          </Swiper>
        </div>

        {/* 底部我的排名 */}
        <footer className={'bottom-box ' + (tab === 0 && visible ? '' : 'hidden-bottom-box')}>
          <b>{myRank.rank || '-'}</b>
          <Image src={myRank.user_avatar || avatar} className='avatar' onClick={() => onToUserPage(myRank.user_id)} />
          <div className='title'>{myRank.user_nickname}</div>
          <aside>
            {
              myRank.rank > 1 ?
              <>
                <h3>{myRank.activity_rank_gap}</h3>
                <p>距上一名</p>
              </> :
              <h1>{myRank.rank === 1 ? 'TOP1' : '暂未上榜'}</h1>
            }
          </aside>
        </footer>
      </section>
    </>
  )
}

export default Invite